export const wrappedSOL = 'So11111111111111111111111111111111111111112';

const tokenRegistry = {
  So11111111111111111111111111111111111111112: {
    chainId: 101,
    address: wrappedSOL,
    symbol: 'SOL',
    name: 'SOL',
    decimals: 9,
    logoURI:
      'https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png',
    tags: [],
    extensions: {
      website: 'https://solana.com/',
      serumV3Usdc: '9wFFyRfZBsuAha4YcuxcXLKwMxJR43S7fPfQLusDBzvT',
      serumV3Usdt: 'HWHvQhFmJB3NUcu1aihKmrKegfVxBEHzwVX6yZCKEsi1',
      coingeckoId: 'solana',
      imageURI: '/resources/solana-logo.gif',
    },
  },
  zRpVjG5wMWrNhpTtSiGMz9iBaMTQDdaVGCFLmYqCs4U: {
    chainId: 101,
    address: 'zRpVjG5wMWrNhpTtSiGMz9iBaMTQDdaVGCFLmYqCs4U',
    symbol: 'TT',
    name: 'TEST TOKEN',
    decimals: 6,
    logoURI:
      'https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/9nusLQeFKiocswDt6NQsiErm1M43H2b8x6v5onhivqKv/logo.png',
    tags: [],
    extensions: {
      website: 'https://sollama.finance',
      twitter: 'https://twitter.com/SollamaFinance',
    },
  },
  'B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi': {
    chainId: 101,
    address: 'B6aJ3TGfme3SMnLSouHXqWXjVFqYyqj7czzhzr8WJFAi',
    symbol: 'RAD',
    name: 'RAD',
    decimals: 4,
    logoURI: `https://raw.githubusercontent.com/NFTBrickLayer/zillaz-assets/main/RAD-logo.png`,
    tags: [],
    extensions: {
      website: 'https://zillaz.org/',
      twitter: 'https://twitter.com/ZillazNFT',
    },
  },
  H32RbcbAoskfMVyPSTNQucEkYP2qvYLkmDg5ij4cPBhH: {
    chainId: 101,
    address: 'H32RbcbAoskfMVyPSTNQucEkYP2qvYLkmDg5ij4cPBhH',
    symbol: 'PM2',
    name: 'Prize Mint 2',
    decimals: 0,
    logoURI:
      'https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/9nusLQeFKiocswDt6NQsiErm1M43H2b8x6v5onhivqKv/logo.png',
    tags: [],
    extensions: {
      website: 'https://sollama.finance',
      twitter: 'https://twitter.com/SollamaFinance',
    },
  },
  '25Wt4PqH3p52Z8nXjQM8QMgtjdym7yanicEgrMznKTMN': {
    chainId: 101,
    address: '25Wt4PqH3p52Z8nXjQM8QMgtjdym7yanicEgrMznKTMN',
    symbol: 'WL',
    name: 'Primates WL',
    decimals: 0,
    logoURI:
      'https://cdn.discordapp.com/attachments/967751804974682152/976479025251889262/unknown.png',
    tags: [],
  },
  '68uwTm2t166hrrFR7u5DYi7PDzDFV34LJDszVW4LnT31': {
    chainId: 101,
    address: '68uwTm2t166hrrFR7u5DYi7PDzDFV34LJDszVW4LnT31',
    symbol: 'WL',
    name: 'Midnight Panthers WL',
    decimals: 0,
    logoURI:
      'https://cdn.discordapp.com/attachments/967751804974682152/978712402893865030/unknown.png',
    tags: [],
  },
  'C43XGj5pYh64EeJgEyk4C72wJiV1vpTWQiGaK1DrEub9': {
    chainId: 101,
    address: 'C43XGj5pYh64EeJgEyk4C72wJiV1vpTWQiGaK1DrEub9',
    symbol: 'Smoking Dogezilla 1/1',
    name: 'Dogezilla 1/1',
    decimals: 0,
    logoURI:
      'https://cdn.discordapp.com/attachments/741098529891680318/981619991860379718/zilla11.jpg', tags: [],
  },
  'AamY54CmEp9CFLKCxy97x2zxhFvqSFbQuZRhLz1mbSjm': {
    chainId: 101,
    address: 'AamY54CmEp9CFLKCxy97x2zxhFvqSFbQuZRhLz1mbSjm',
    symbol: 'RENNT',
    name: 'Rent',
    decimals: 9,
    logoURI:
      'https://raw.githubusercontent.com/genties/rennt/main/logo.png',
    tags: [],
  },
  '8uzrKytvF1FbcK9VPYVRBkL2XGB7Hnv9a1nrwSRL17iA': {
    chainId: 101,
    address: '8uzrKytvF1FbcK9VPYVRBkL2XGB7Hnv9a1nrwSRL17iA',
    symbol: 'Zillaz 1/1 + Rare',
    name: 'Zillaz 1/1 + Rare',
    decimals: 0,
    logoURI:
      'https://bafkreifrmvfyfswtrqjqujpuxnwefm6ryib2sczv2zvttsr2eqplvaojnq.ipfs.nftstorage.link/',
    tags: [],
  },
  'BC1fTEiMPfKoebD3J2YxFdxAZCyA8bj3DJncytoGxFCQ': {
    chainId: 101,
    address: 'BC1fTEiMPfKoebD3J2YxFdxAZCyA8bj3DJncytoGxFCQ',
    symbol: 'Primates #1925',
    name: 'Primates #1925',
    decimals: 0,
    logoURI:
      'https://cdn.discordapp.com/attachments/967751804974682152/987081455689662514/unknown.png',
    tags: [],
  }
};

export const tokenInfoMap = new Map(Object.entries(tokenRegistry));

export const UNKNOWN_TOKEN_INFO = {
  chainId: 101,
  symbol: 'WL',
  name: 'WL',
  decimals: 0,
  logoURI:
    '',
  tags: [],
  extensions: {},
};
